import React from "react";
import { Routes, Route } from "react-router-dom";

// HR Pages (all must be default exports)
import Dashboard from "../pages/HR/Dashboard";
import Employees from "../pages/HR/Employees";
import AddEmployee from "../pages/HR/AddEmployee";
import EmployeeProfile from "../pages/HR/EmployeeProfile";
import Leaves from "../pages/HR/Leaves";
import Attendance from "../pages/HR/Attendance";
import Payroll from "../pages/HR/Payroll";
import Departments from "../pages/HR/Departments";
import Recruitment from "../pages/HR/Recruitment";
import Holidays from "../pages/HR/Holidays";
import Reports from "../pages/HR/Reports";

export default function HrRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="employees" element={<Employees />} />
      <Route path="add-employee" element={<AddEmployee />} />
      <Route path="employee/:id" element={<EmployeeProfile />} />
      <Route path="leaves" element={<Leaves />} />
      <Route path="attendance" element={<Attendance />} />
      <Route path="payroll" element={<Payroll />} />
      <Route path="departments" element={<Departments />} />
      <Route path="recruitment" element={<Recruitment />} />
      <Route path="holidays" element={<Holidays />} />
      <Route path="reports" element={<Reports />} />
    </Routes>
  );
}
